import React from 'react';
import { IconProps } from './typing';

const Add = ({
  iconSize = 12,
  background = 'none',
  color = "currentColor"
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={iconSize}
    height={iconSize}
    viewBox={`0 0 ${iconSize} ${iconSize}`}
    fill={background}
  >
    <path
      d="M6.66 5.46V1H5.34V5.46H1V6.79H5.34V11.23H6.66V6.79H11V5.46H6.66Z"
      fill={color}
    />
  </svg>
);

export default Add;
